<template>
  <div class="flex items-center">
    <input
      :id="id"
      :name="name"
      type="checkbox"
      :checked="modelValue"
      @change="$emit('update:modelValue', $event.target.checked)"
      class="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-700 rounded bg-gray-700"
    />
    <label :for="id" class="ml-2 block text-sm text-gray-400">
      <slot>{{ label }}</slot>
    </label>
  </div>
</template>

<script>
export default {
  name: 'FormCheckbox',
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
